<template>
  <el-row>
    <el-col :span="22">
      <el-time-picker
        is-range
        v-model="mutation"
        range-separator="—"
        start-placeholder="開始時間"
        end-placeholder="結束時間"
        :picker-options="timePickerOptions"
        value-format="HH:mm"
        size="mini"
        :clearable="false"
        @change="changeTimePicker($event)"
      >
      </el-time-picker>
    </el-col>
    <el-col :span="2">
      <a class="delete" @click="deleteTimePickerObj()"
        ><FontAwesomeIcon icon="trash"
      /></a>
    </el-col>
  </el-row>
</template>
<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: {
    "font-awesome-icon": FontAwesomeIcon,
    FontAwesomeIcon
  },
  props: {
    code: String,
    name: String,
    value: [Object],
    index: Number,
    placeholder: String,
    dbTable: String
  },
  data() {
    return {
      originValue: "",
      type: "Object",
      timePickerOptions: {
        format: "HH:mm"
      },
      mutation: ""
    };
  },
  created() {
    console.log("this.value: ", this.value);
    this.originValue = this.value;
    this.mutation = this.convertToTimePickerFormat(this.value);
  },
  computed: {
    saveIconStatus() {
      console.log(this.mutation, this.originValue);
      return this.mutation !== this.originValue;
    }
  },
  methods: {
    save: function() {
      console.log("save");
      if (this.mutation !== this.originValue) {
        this.$emit("update-select", {
          code: this.code,
          name: this.name,
          dbTable: this.dbTable,
          mutation: this.mutation,
          origin: this.originValue,
          type: this.type
        });
        this.originValue = this.mutation;
      }
    },
    changeTimePicker(event) {
      console.log(
        "this.convertToDbFormat(event): ",
        this.convertToDbFormat(event),
        this.index
      );
      let result = {
        code: this.code,
        name: this.name,
        dbTable: this.dbTable,
        mutation: this.convertToDbFormat(event),
        origin: this.originValue,
        type: this.type
      };
      this.$emit("update-time-picker", result, this.index);
    },
    convertToTimePickerFormat(dbFormatObj) {
      return [dbFormatObj.start, dbFormatObj.end];
    },
    convertToDbFormat(timePickerFormatArr) {
      return {
        start: timePickerFormatArr[0],
        end: timePickerFormatArr[1]
      };
    },
    deleteTimePickerObj() {
      let result = {
        code: this.code,
        name: this.name,
        dbTable: this.dbTable,
        type: this.type
      };
      this.$emit("delete-time-picker", result, this.index);
    }
  },
  watch: {
    mutation: function(newVal, oldVal) {
      console.log(newVal);
      return newVal;
    },
    value: function(newVal, oldVal) {
      console.log("value: ", newVal);
      this.mutation = this.convertToTimePickerFormat(newVal);
      return newVal;
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>
